import { useDialog } from "../DialogProvider/DialogProvider";
import './SignUpSuccess.css'

function SignUpSuccess({ show }) {
    const { openDialog, closeDialog, animation } = useDialog();
    return (
        show && <div className='popup-wrapper' onClick={ closeDialog }>
            <div className='popup-body animation' style={{ animationName: animation }} onClick={(e) => e.stopPropagation()}>
                <div className="d-flex flex-column gap-48">
                    <div className="d-flex flex-column gap-24">
                        <div className='bold-heading'> Welcome to BrainyClock! </div>
                        <div className="theme-heading-text-24">Your account has been successfully created. </div>
                    </div>
                    <div className="d-flex flex-column gap-16">
                        <p className="theme-text-small-16">Access your dashboard to start setting up your account and explore BrainyClock's features.</p>
                        <div><button className="menu-btn-theme signup-success-btn" onClick={() => {
                            window.open("https://portal.brainyclock.com", "_blank");
                        }}>Log in Now</button></div>
                    </div>
                    <div className="d-flex flex-column gap-16">
                        <p className="theme-text-small-16">Would you like to schedule a personalized demo to explore all the features BrainyClock has to offer? </p>
                        <div><button className="menu-outline-btn-theme signup-success-btn" onClick={() => openDialog('bookdemo')} >Book a Demo</button></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SignUpSuccess
